import React from 'react'
import Select from 'react-select'
import { InputWrapper } from '../Field/styles'
import '../Field/index.css'

/* TODO: Alterar estes dados para puxar do banco de dados (ver Multiselect) */
const groupedOptions = [
  {
    label: 'Apartamento',
    options: [
      { label: 'Apartamento Padrão', value: 'apartment' },
      { label: 'Quitinete', value: 'kitchenette' },
      { label: 'Studio', value: 'studio' },
      { label: 'Duplex', value: 'duplex' },
      { label: 'Triplex', value: 'triplex' },
      { label: 'Flat', value: 'flat' },
      { label: 'Cobertura', value: 'penthouse' },
      { label: 'Loft', value: 'loft' },
    ],
  },
  {
    label: 'Casa',
    options: [
      { label: 'Casa Padrão', value: 'house' },
      { label: 'Sobrado', value: 'houseLoft' },
      { label: 'Casa Geminada', value: 'semiDetachedHouse' },
      { label: 'Casa em Condomínio', value: 'condoHouse' },
      { label: 'Sobrado Geminado', value: 'semiDetachedHouseLoft' },
      { label: 'Sobrado em Condomínio', value: 'condoLoft' },
    ],
  },
  {
    label: 'Comercial',
    options: [
      { label: 'Sala Comercial', value: 'comercialRoom' },
      { label: 'Loja', value: 'store' },
      { label: 'Conjunto', value: 'housing' },
      { label: 'Laje', value: 'slab' },
      { label: 'Sobreloja', value: 'mezzanine' },
      { label: 'Casa Comercial', value: 'comercialHome' },
      { label: 'Ponto', value: 'comercialSpot' },
    ],
  },
]

const customStyles = {
  control: provided => ({
    ...provided,
    minHeight: '32px',
    maxHeight: '32px',
    backgroundColor: '#F3F5F9',
    borderRadius: '4px',
    fontWeight: '600',
    fontSize: '13.5px',
    cursor: 'pointer',
    color: '#454e5b',
  }),
  input: provided => ({
    ...provided,
    paddingTop: '0',
  }),
  placeholder: provided => ({
    ...provided,
    color: '#454e5b',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  indicatorContainer: provided => ({
    ...provided,
    width: '15px',
    height: '15px',
  }),
  dropdownIndicator: provided => ({
    ...provided,
    minHeight: '32px',
    maxHeight: '32px',
    height: '32px',
    alignItems: 'center',
  }),
  singleValue: provided => ({
    ...provided,
    color: '#454e5b',
  }),
  groupHeading: provided => ({
    ...provided,
    color: '#454e5b',
    fontSize: '14px',
    fontWeight: '600',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#6F7987' : '#fff',
    color: state.isFocused ? '#fff' : '#454e5b',
    fontSize: '14px',
    paddingLeft: '28px',
  }),
}

const SelectComponent = ({
  name,
  category = false,
  placeholder,
  error,
  options,
  value,
  onChange,
  ...props
}) => {
  return (
    <>
      <InputWrapper noMargin>
        <Select
          name={name}
          value={value}
          styles={customStyles}
          placeholder={placeholder}
          options={category ? groupedOptions : options}
          noOptionsMessage={() => 'Nenhuma opção encontrada'}
          onChange={onChange}
        />
      </InputWrapper>
    </>
  )
}

export default SelectComponent
